import { createFileRoute } from '@tanstack/react-router'
import { AdminAudit } from '../features/admin'
import { auditQuery, peopleQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/audit')({
  ...adminRouteState,
  loader: ({ context }) =>
    Promise.all([context.queryClient.ensureQueryData(auditQuery()), context.queryClient.ensureQueryData(peopleQuery())]),
  component: AdminAudit,
})
